// extracted by mini-css-extract-plugin
module.exports = {"all_center":"hGaeXpVO","detail_wrapper":"_15pG2y_","infiniteRotating":"fVyNTt5d","fadeInOpacity":"BD_MEHCK"};